import { createI18n } from "vue-i18n";
import messages from "./messages";
import { APP_LOCALES, DEFAULT_APP_LOCALE, resolveAppLocale, resolveInitialAppLocale, } from "./locale";
let storedLocale = null;
try {
    storedLocale = localStorage.getItem("app_locale");
}
catch {
    // Public pages still use the browser locale when storage is unavailable.
}
const initialLocale = resolveInitialAppLocale({
    stored: storedLocale,
    browser: window.navigator.language,
});
export const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: initialLocale,
    fallbackLocale: DEFAULT_APP_LOCALE,
    availableLocales: [...APP_LOCALES],
    missingWarn: process.env.NODE_ENV !== "production",
    fallbackWarn: process.env.NODE_ENV !== "production",
    messages,
});
export function setAppLocale(value) {
    const locale = resolveAppLocale(value);
    i18n.global.locale.value = locale;
    try {
        localStorage.setItem("app_locale", locale);
    }
    catch {
        // Locale changes remain available in memory.
    }
    document.documentElement.lang = locale;
    return locale;
}
export function translateApp(key, variables) {
    return i18n.global.t(key, variables);
}
export function getCurrentAppLocale() {
    return i18n.global.locale.value;
}
setAppLocale(initialLocale);
export { APP_LOCALES, DEFAULT_APP_LOCALE, resolveAppLocale, resolveInitialAppLocale, };
